export const chainsSupportingOffers = ['bsx']
